// test2061
(2061 && 0);
